import React from 'react';
import { Field } from 'formik';
import { Row, Col } from 'react-bootstrap';
import ErrorMessage from '@common/components/validation/errorMessages.component';
import _ from 'lodash';
import autoBind from 'react-autobind';
import commonMessages from '@common/constraints/common.messages';
import * as commonActionType from '@common/store/common/common.actionsType';

class FieldInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
    this.lastValue = undefined;
    autoBind(this);
  }

  validateFormControl() {
    const { onDisableFormUpdated } = this.props;
    if (!onDisableFormUpdated) window.formUpdated = true;
  }

  static getDerivedStateFromProps(props, currentState) {
    const { name, state, stateName } = props;
    if (state) {
      if (JSON.stringify(state) != JSON.stringify(currentState.state)) {
        const value = state[stateName || name];
        return {
          value,
          state,
        };
      }
    }
    return null;
  }

  componentDidMount() {
    this.state.pS_Reset = PubSub.subscribe(commonActionType.RESET, this.onResetForm.bind(this));
    this.state.pS_updateForm = PubSub.subscribe(commonActionType.UPDATE_FORM, this.checkUpdateForm.bind(this));
    this.state.pS_ClearInput = PubSub.subscribe(commonActionType.CLEAR_INPUTS_GRID, this.onClearInputGrid.bind(this));
    this.state.pS_ValidationReset = PubSub.subscribe(
      commonActionType.VALIDATION_RESET,
      this.onResetFormTabWizard.bind(this)
    );
    this.checkUpdateForm();
  }

  componenWillUnmount() {
    PubSub.unsubscribe(this.state.pS_Reset);
    PubSub.unsubscribe(this.state.pS_updateForm);
    PubSub.unsubscribe(this.state.pS_ClearInput);
    PubSub.unsubscribe(this.state.pS_ValidationReset);
  }

  componentDidUpdate() {
    this.checkUpdateForm();
  }

  checkUpdateForm() {
    const { form, props, state, lastValue } = this;
    const { name, Tipo } = props;
    const { value } = state;
    let jsonValue = undefined;
    if (Tipo !== 'file') {
      jsonValue = JSON.stringify(value);
    } else {
      if (value) {
        var obj = {
          lastModified: value.lastModified,
          lastModifiedDate: value.lastModifiedDate,
          name: value.name,
          size: value.size,
          type: value.type,
        };
        jsonValue = JSON.stringify(obj);
      } else jsonValue = JSON.stringify(value);
    }

    if (!this.timeout && lastValue != jsonValue) {
      this.lastValue = jsonValue;
      setTimeout(() => {
        form.setFieldTouched(name);
        form.setFieldValue(name, value);
      });
    }
  }

  onResetFormTabWizard(action) {
    this.form.resetForm();
  }

  onResetForm() {
    const value = this.props.state ? this.props.state[this.props.stateName || this.props.name] : '';
    this.onChange(value, true);
  }

  onClearInputGrid() {
    const value = this.props.state ? this.props.state[this.props.stateName || this.props.name] : '';
    this.setValue(value);
    this.form.setFieldValue(this.props.name, value);
  }

  setValue(value) {
    this.setState({ value });
  }

  validate(value) {
    const { props } = this;

    if (!value) value = this.props.state ? this.props.state[this.props.stateName || this.props.name] : undefined;

    if (props.Tipo != 'multiselectcombobox') {
      if (props.Tipo != 'decimal') {
        if (props.Tipo != 'combobox') {
          if (props.Tipo == 'file') {
            if (props.Obrigatorio && !value) return commonMessages.validations.REQUIRED_IVALID;
          }
          if (props.Tipo == 'mask') {
            var valueOut = value ? value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '').trim() : value;
            if (props.Obrigatorio && !valueOut) return commonMessages.validations.REQUIRED_IVALID;
          }

          if (props.AceitaValorZero) {
            if (props.Obrigatorio && (value === null || value === undefined || value === ''))
              return commonMessages.validations.REQUIRED_IVALID;
          } else {
            if (props.Obrigatorio && !value) return commonMessages.validations.REQUIRED_IVALID;
          }
        } else {
          if (props.AceitaValorZero) {
            if (props.Obrigatorio && (value === null || value === undefined || value === '')) {
              return commonMessages.validations.REQUIRED_IVALID;
            }
          } else if (props.Obrigatorio && (value === '' || !value)) {
            return commonMessages.validations.REQUIRED_IVALID;
          }
        }

        if (value) {
          let length = value.length;
          if (props.Tamanho && length > props.Tamanho)
            return commonMessages.validations.MAX_LENGTH_INVALID(props.Tamanho);
          if (props.TamanhoMinimo && length < props.TamanhoMinimo)
            return commonMessages.validations.MIN_LENGTH_INVALID(props.TamanhoMinimo);
        }
      } else {
        if (props.Obrigatorio && (value === undefined || value === null))
          return commonMessages.validations.REQUIRED_IVALID;
      }
    } else {
      if (props.Obrigatorio && props.state && props.state.length === 0) {
        return commonMessages.validations.REQUIRED_IVALID;
      }
    }

    if (props.Tipo === 'phone' && props.dddObrigatorio && value?.length) {
      const onlyNumbers = value.replace(/\D/g, '');

      const validPhone =
        (onlyNumbers.length === 11 && onlyNumbers.startsWith('0800')) ||
        (onlyNumbers.length === 8 && onlyNumbers.startsWith('4004')) ||
        onlyNumbers.length === 10 ||
        onlyNumbers.length === 11;

      if (!validPhone) return commonMessages.validations.TELEFONE_INVALID;
    }

    return this.props.validate && this.props.validate(value);
  }

  errorsInField(form) {
    if (!form || !form.errors) return;

    const { name } = this.props;

    if (name && name.toString().includes('.')) {
      const splitedValue = name.split('.');
      return form.errors[splitedValue[0]] ? form.errors[splitedValue[0]][splitedValue[1]] : false;
    }
    return form.errors[name];
  }

  hasError(form) {
    return this.errorsInField(form) && form.submitCount > 0;
  }

  dispatchChanges(value, form) {
    let { values } = form;
    values[this.props.name] = value;
    PubSub.publish(commonActionType.SET_FIELD_VALUE, { [this.props.name]: value });
    this.props.onChange && this.props.onChange(value, { values });
  }

  dispatchChangesFile(value, form, fileName) {
    let { values } = form;
    values[this.props.name] = value;
    PubSub.publish(commonActionType.SET_FIELD_VALUE, { [this.props.name]: value });
    this.props.onChange && this.props.onChange(value, { values }, fileName);
  }

  preventEnterKey(e) {
    if (e.key === 'Enter') {
      this.onChange(this.state.value);
    }
  }

  onChange(e, notDispatchChanges) {
    const { form } = this;
    const value = e && e.target ? e.target.value : e;

    this.validateFormControl();

    this.setValue(value);
    form.setFieldValue(this.props.name, value);
    if (!notDispatchChanges) this.dispatchChanges(value, form);
  }

  onChangeFile(e, notDispatchChanges, fileName) {
    const { form } = this;
    const value = e && e.target ? e.target.value : e;

    this.validateFormControl();

    this.setValue(value);
    form.setFieldValue(this.props.name, value);
    if (!notDispatchChanges) this.dispatchChangesFile(value, form, fileName);
  }

  onChangeAsync(e) {
    if (this.props.forceSync) {
      this.onChange(e);
    } else {
      const { form } = this;
      const value = e && e.target ? e.target.value : e;
      this.setValue(value);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.validateFormControl();

        form.setFieldValue(this.props.name, value);
        this.dispatchChanges(value, form);
        this.timeout = null;
      }, 100);
    }
  }

  onBlur() {
    const { form } = this;
    const { value } = this.state;

    this.validateFormControl();

    form.setFieldValue(this.props.name, value);
    this.dispatchChanges(value, form);
    this.props.onBlur && this.props.onBlur(value);
  }

  render() {
    const { name, errorMessage, errorMessageOnSubmit, hideErrorMessageOnSubmit } = this.props;
    const { value } = this.state;
    const { onChange, onChangeFile, onBlur, onChangeAsync, preventEnterKey } = this;
    return (
      <Field name={name} validate={this.validate}>
        {({ form, field }) => {
          this.form = this.form || form;

          const hasErrorMessage = hideErrorMessageOnSubmit
            ? form?.submitCount == 0 && !!errorMessage
            : errorMessageOnSubmit
            ? form?.submitCount > 0 && !!errorMessage
            : !!errorMessage;
          const hasErrorForm = this.hasError(form);
          const hasError = hasErrorForm || hasErrorMessage;
          const props = {
            ...this.props,
            value,
            hasError,
            hasErrorMessage,
            hasErrorForm,
            onChange,
            onChangeAsync,
            preventEnterKey,
            onBlur,
            form,
            field,
            onChangeFile,
          };
          return <Item {...props} />;
        }}
      </Field>
    );
  }
}

let Item = React.memo((props) => {
  const { hasErrorForm, form, errorMessage, hasErrorMessage } = props;

  return (
    <Row>
      <Col>
        {props.children(props)}
        <div style={{ marginTop: props?.Desabilitado && props.Tipo === 'date' ? '6px' : '' }}>
          <ErrorMessage
            {...props}
            hasErrorForm={hasErrorForm}
            hasErrorMessage={hasErrorMessage}
            form={form}
            errorMessage={errorMessage}
          />
        </div>
      </Col>
    </Row>
  );
});

export default FieldInput;
